// src/services/ActivityService.js
import axios from 'axios';
import axiosInstance from './ApiService';

export const fetchActivitiesForUser = async (username, startDate, endDate, nextPageToken = undefined, pageSize = 10) => {
   try {
      const paramsObj = { username, startDate, endDate, nextPageToken, pageSize };

      // Create a new object excluding keys with undefined or null values
      const filteredParams = Object.fromEntries(
         Object.entries(paramsObj).filter(([key, value]) => value !== undefined && value !== null)
      );

      const params = new URLSearchParams(filteredParams);

      const response = await axiosInstance.get(`/activities?${params.toString()}`);
      const activitiesData = response.data;

      // Validate the paginated response
      if (Array.isArray(activitiesData.data) &&
         (
            typeof activitiesData.isLast === 'boolean' ||
            typeof activitiesData.lastEvaluatedKey === 'string'
         )) {
         return activitiesData;
      } else {
         console.error('Unexpected response format:', response);
         throw new Error('Unexpected response format');
      }
   } catch (error) {
      console.error('Error fetching paginated activities for user:', error);
      throw error;
   }
};

export const fetchPaginatedActivities = async (nextPageToken = undefined, pageSize = 10) => {
   const paramsObj = { nextPageToken, pageSize };

   // Create a new object excluding keys with undefined or null values
   const filteredParams = Object.fromEntries(
      Object.entries(paramsObj).filter(([key, value]) => value !== undefined && value !== null)
   );

   const params = new URLSearchParams(filteredParams);
   const response = await axiosInstance.get(`/activities?${params.toString()}`);
   return response.data;
};

export const registerActivity = async (activityData) => {
   try {
      console.log('Registering activity with data:', activityData);
      const response = await axiosInstance.post('/activities', {
         ...activityData,
         attachments: activityData.attachments.map(attachment => ({
            name: attachment.name,
            type: attachment.type
         }))
      });
      const activity = response.data.data;

      // Upload attachments if any
      if (activity.attachments && activity.attachments.length > 0) {
         // Use a new axios instances without Authorization header, as we should not specify this.
         // The url returned by the backend already has authorization information in it.
         const uploadAxios = axios.create({
            headers: {
              Accept: 'application/json',
              Authorization: undefined,
            },
          });
         for (const attachment of activity.attachments) {
            const originalAttachment = activityData.attachments.find(a => a.name === attachment.name);
            const { url, fileType } = attachment;
            console.log('Uploading attachment:', originalAttachment);
            try {
               const uploadResponse = await uploadAxios.put(url, originalAttachment.file, {
                  headers: {
                     'Content-Type': fileType
                  }
               });
               console.log('Upload response:', uploadResponse);
            } catch (uploadError) {
               console.error('Error uploading attachment:', uploadError);
               console.error('Attachment URL:', url);
               console.error('Attachment file:', originalAttachment.file);
            }
         }
      }

      return response;
   } catch (error) {
      console.error('Error registering activity:', error);
      throw error;
   }
};
